<template>
  <router-view />
</template>

<style lang="scss">
// 3rd party plugins css
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~perfect-scrollbar/css/perfect-scrollbar.css';
@import '~socicon/css/socicon.css';
@import '~animate.css';
@import '~@fortawesome/fontawesome-free/css/all.css';
@import '~line-awesome/dist/line-awesome/css/line-awesome.css';
@import 'assets/plugins/flaticon/flaticon.css';
@import 'assets/plugins/flaticon2/flaticon.css';
@import 'assets/plugins/keenthemes-icons/font/ki.css';

// Main demo style scss
@import 'assets/sass/style.vue';
</style>

<script>
import { ADD_BODY_CLASSNAME } from '@/core/services/store/htmlclass.module.js'

// apps data
import store from '@/core/services/store'
import {
  UPDATE_SELECTED_REGION,
  FETCH_REGIONS,
} from '@/core/services/store/regions.module'

export default {
  name: 'MetronicVue',
  created() {
    // check if isLogin first
    console.log('call shared data from API here..')
  },
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, 'page-loading')
  },
  async mounted() {
    // get initial data
    await this.fetchData()
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      store.dispatch(FETCH_REGIONS)
      // update selected region
      store.dispatch(UPDATE_SELECTED_REGION, this.preSelectedRegion())
    },
    preSelectedRegion() {
      let id = '1'
      let name = 'INDONESIA'

      return {
        region_id: id,
        name: name,
      }
    },
  },
}
</script>
